export enum AutomationRuleType {
  Unknown = 0,
  ReceiptDraft = 1,
}
